import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, Renderer} from "@angular/core";
import { AuthorizationPipe } from "../../common/pipes/authorization.pipe";
import { Permission } from "../../common/enums/permission.enum";
import { DistributorInfo } from "../interface/ticketingsystem/distributor-info";
import { MemberTypeEnum } from "../enums/member-type.enum";



@Component({
    selector: "customer-tickets-create",
    templateUrl: "../templates/template1/views/ticket-create.component.html",
    styleUrls: [
        "../templates/template1/themes/default/css/ticket.less"
    ],
    providers: [AuthorizationPipe]
})
export class TicketCreateComponent implements OnInit {
    @Input() fboid: string;
    @Input() isDisputeTicketCreation: boolean;
    @Input() webOrderID: string;
    @Output() onActiveTicketTab: EventEmitter<any> = new EventEmitter<any>();
    @Input() distributorInfo: DistributorInfo;
    @ViewChild('workTicket') workTicket: ElementRef;
    @ViewChild('disputeTicket') disputeTicket: ElementRef;
    @Input() tabIndex: number;
    @Input() countryCode: String;
    memberTypeEnum = MemberTypeEnum;
 
    constructor(private renderer: Renderer,
      ) { };
    FBOManageTicketPermissions: any[] = [
        Permission.MANAGE_TICKETS_CREATE,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
        Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
        Permission.MANAGE_TICKETS_VIEW
    ];
    ManageDepartmentPermissions: any[] = [
        Permission.MANAGE_DEPARTMENT_TICKETS_CLOSE,
        Permission.MANAGE_DEPARTMENT_TICKETS_RE_OPEN,
        Permission.MANAGE_DEPARTMENT_TICKETS_EDIT,
        Permission.MANAGE_DEPARTMENT_TICKETS_SELF_ASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_REASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN
    ];
    tickets: any[] = ["WorkTicket", "DisputeTicket"];
    ticket: string;
    ticketTypeName:string;
    ngOnInit(): void {
        this.ticketTypeName = "ticket#" + this.tabIndex;
        if(this.webOrderID) {
            this.ticket = this.tickets[1];
            this.renderer.invokeElementMethod(this.disputeTicket.nativeElement, 'focus');
        }
        else {
        this.ticket = this.tickets[0];
        this.renderer.invokeElementMethod(this.workTicket.nativeElement, 'focus');
        }

    }
    // setFocusToTextBox(){
    //     setTimeout(function(){ 
    //         document.getElementById("workTicket").focus();
    //      }, 1000);
    // }

    // ngAfterViewInit() {
    //    this.setFocusToTextBox();
    //   }


  
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/ticket-create.component.ts